import React, { useState, useEffect } from "react";
import Modal from "../../common/Modal/Modal";
import { SubmitCSV } from "../../csv/SubmitCompletedCSV";
import Papa from "papaparse";
import { getUnfilledCompulsoryFields } from "./CheckCompletedForm";
import { useNavigate, useOutletContext } from "react-router-dom";
import { retrieveData, formatCSVData } from "../../csv/JSONtoCSV";
import { generateNameIfNoInputtedName } from "../../snapshots/NewSnapshot/GenerateFileName";

/* 
  Modal for submit completed form functionality
*/

export default function SubmitCompletedModal({setUnfilledFields}) {
  // Initialise use States
  const [openModal, setOpenModal] = useState(false);
  const [inputtedFileName, setInputtedFileName] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);

  useEffect(() => {
    getS3().then(setS3);
  }, [])

  // redirect user to snapshots pager after submitting file
  const goBacktoSnapshots = () => {
    localStorage.removeItem("companyNameEditable");
    localStorage.removeItem("formattedDataArray");
    localStorage.removeItem("UpdatedDataArray");
    localStorage.removeItem("companyName");
    localStorage.removeItem("timestamp");
    navigate("/snapshots");
  };

  // Initialise variables
  const initialFileName = localStorage.getItem("initialFileName");
  //const generatedCSV = JSONtoCSV();

  // Modal Handling Functions
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    if (isSuccess === true) {
      goBacktoSnapshots();
    } else if (isError === true) {
      if (errorMessage === "DuplicateError") {
        // If the error message is a duplicate error, reload the modal
        handleReloadModal();
      } else {
        // If it's any other error message, simply close the modal
        setOpenModal(false);
      }
    } else {
      setOpenModal(false);
    }
    setIsError(false);
    setIsSuccess(false);
  };

  const handleReloadModal = () => {
    setIsError(false);
  };

  const handleInputChange = (event) => {
    setInputtedFileName(event.target.value);
    setIsError(false); // Clear the error message when input changes
  };

  const handleSubmitCompletedForm = async () => {
    const unfilledFields = getUnfilledCompulsoryFields();
    if (unfilledFields.length > 0) {
      setUnfilledFields(unfilledFields);
      setIsError(true);
      setErrorMessage(
        <>
          Your report could not be submitted to HecoAnalytics as you have not
          provided some compulsory (<span style={{ color: "red" }}>*</span>)
          data. Please check your form and ensure all data has been provided.
        </>
      );
      return;
    } 

      try {
      //Check if the name exists and format it according to specifics (depending if it's RepX/regular Snapshot file)
      const generatedNewName = generateNameIfNoInputtedName(initialFileName, inputtedFileName, setInputtedFileName, false);
      localStorage.setItem("selectedSnapshot", generatedNewName);

        // Create the CSV string when csvData changes
        const csvData = await retrieveData();

        const formattedCSVData = formatCSVData(csvData);
        const csvString = Papa.unparse(formattedCSVData);
        await SubmitCSV(S3, initialFileName, generatedNewName, csvString);
        setIsSuccess(true);
      } catch (error) {
        setIsError(true);
        if (error.message === "UploadError") {
          setErrorMessage(
            "There was an error during the upload of the report. Please try again later."
          );
        } else if (error.message === "DuplicateError") {
          setErrorMessage(
            "There is another snapshot with the same name already exists. Please try another name."
          );
        } else {
          setErrorMessage(error.message);
        }
      }
  };

  return (
    <>
      {/* Submit button on Input Form Page */}
      <button className="green-button" style={{width: 86}} onClick={handleOpenModal}>
        Submit
      </button>

      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={isError ? "Error Submitting Report" : "Submit Snapshot"}
        showCustomContent={true}
        customContent={
          isSuccess ? (
            // If submits successfully to S3
            <>
              <div className="modal-success-container">
                <div className="icon-container">
                  <i className="fas fa-check" />
                </div>
                <p className="success-message">
                  You have successfully submitted your snapshot!
                </p>
              </div>
              <div className="button-close-container">
              <button className="button-close" onClick={handleCloseModal}>
                Okay
              </button>
              </div>
            </>
          ) : isError ? (
            //   It submits unsuccessfully
            <>
              <div className="error-message">{errorMessage}</div>
              <div className="button-close-container">
                <button
                  className="button-close"
                  // onClick={handleCloseModal}
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </>
          ) : (
            // Default state -> No success & no error
            <>
              <p className="savesubmitmodal-description">Submit your data to S3.</p>
              <div className="modal-input-container">
                <input
                  value={inputtedFileName}
                  onChange={handleInputChange}
                  placeholder={initialFileName}
                />
              </div>
              <div className="button-close-container">
                <button
                  className="button-close"
                  onClick={handleSubmitCompletedForm}
                >
                  Submit
                </button>
              </div>
            </>
          )
        }
      />
    </>
  );
}
